import { selectUserFeatures } from 'store/user/selectors';

import { useSelector } from 'hooks/store';
import { useUserLoggedIn } from 'hooks/user';

export const usePersonalPlanAvailable = (): boolean => {
    const features = useSelector(selectUserFeatures);

    const isLoggedIn = useUserLoggedIn();

    return Boolean(isLoggedIn && features?.length);
};
